import "./Footer.css";

function EmailIcon() {
  return (
    <svg preserveAspectRatio="none" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33.6 15H14.4C13.08 15 12.012 16.0687 12.012 17.375L12 31.625C12 32.9313 13.08 34 14.4 34H33.6C34.92 34 36 32.9313 36 31.625V17.375C36 16.0687 34.92 15 33.6 15ZM33.6 19.75L24 25.6875L14.4 19.75V17.375L24 23.3125L33.6 17.375V19.75Z" fill="#F3F4F6" />
    </svg>
  );
}

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer" id="footer">
      <div className="footer__inner">
        <div className="footer__icons">
          <a
            href="https://www.linkedin.com/in/vasapon-opaswatanakul"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <img src={`${process.env.PUBLIC_URL}/linkedin-icon.png`} alt="LinkedIn" width="48" height="48" />
          </a>
          <a href="mailto:vasapon.contact@gmail.com" aria-label="Email">
            <EmailIcon />
          </a>
        </div>
        <hr className="footer__divider" />
        <p className="footer__copy">© Vasapon Opaswatanakul {year} All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
